import axios from "axios";
import authHeader from '../../../authheader'

const PLSRENEWALURL = process.env.REACT_APP_APIURL + "/api/IndividualPlsRenewal";

const getCpdRequirements = (renewalId) => {
    return axios.get(`${PLSRENEWALURL}/cpd`, { headers: authHeader(), params: { renewalId } });
}
const postCpdRequirements = (data) => {
    return axios.post(`${PLSRENEWALURL}/cpd`, data, { headers: authHeader() });
}
const isCpdRequired = (renewalId) => {
    return axios.get(`${PLSRENEWALURL}/iscpdrequired`, { headers: authHeader(), params: { renewalId } });
}
const isNonActiveToActive = (renewalId) => {
    return axios.get(`${PLSRENEWALURL}/isnonactivetoactive`, { headers: authHeader(), params: { renewalId } });
}
export default {
    getCpdRequirements,
    postCpdRequirements,
    isCpdRequired,
    isNonActiveToActive
}